import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VForm,
        {
          ref: "form",
          model: {
            value: _vm.validForm,
            callback: function ($$v) {
              _vm.validForm = $$v
            },
            expression: "validForm",
          },
        },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "6" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-4" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("my_tasks.tablas_tasks.user_pbi")
                                ) + ":"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-8" },
                        [
                          _c(VTextField, {
                            attrs: { dense: "", filled: "", readonly: "" },
                            model: {
                              value: _vm.record.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "email", $$v)
                              },
                              expression: "record.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "12", lg: "6" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("my_tasks.tablas_tasks.name")) +
                                  ":"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VTextField, {
                            attrs: { dense: "", filled: "", readonly: "" },
                            model: {
                              value: _vm.record.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.record, "name", $$v)
                              },
                              expression: "record.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("my_tasks.tablas_tasks.user_inca")
                                ) + ":"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-10" },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              placeholder: "user@domain.com",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                                function (v) {
                                  return (
                                    /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                      v
                                    ) || _vm.$t("my_tasks.modals.email_invalid")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.record.user_dp,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.record,
                                  "user_dp",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "record.user_dp",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountDown,
                        dismissible: "",
                        variant: "danger",
                      },
                      on: {
                        dismissed: function ($event) {
                          _vm.dismissCountDown = 0
                        },
                        "dismiss-count-down": _vm.countDownChanged,
                      },
                    },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                      _c("b-progress", {
                        attrs: {
                          variant: "danger",
                          max: _vm.dismissSecs,
                          value: _vm.dismissCountDown,
                          height: "4px",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }